import ToursList from "./ToursList";

const FALLBACK = [
  { title: "Char Dham Group Yatra — May 2026", destination: "Uttarakhand", duration: "11N/12D", price: 45000, price_label: "per person", image_url: "https://images.pexels.com/photos/16152405/pexels-photo-16152405.jpeg", short_description: "Group departure with 25-30 pilgrims. Confirmed dates.", is_featured: true },
  { title: "Kashmir Group — Apr 2026", destination: "Kashmir", duration: "6N/7D", price: 30000, price_label: "per person", image_url: "https://images.pexels.com/photos/2670898/pexels-photo-2670898.jpeg", short_description: "Spring tulips, Gulmarg snow, Pahalgam." },
  { title: "Dubai Group — Dec 2025", destination: "UAE", duration: "5N/6D", price: 52000, price_label: "per person", image_url: "https://images.pexels.com/photos/618079/pexels-photo-618079.jpeg", short_description: "New Year in Dubai — fireworks at Burj Khalifa." },
  { title: "Goa New Year Group", destination: "Goa", duration: "3N/4D", price: 18000, price_label: "per person", image_url: "https://images.pexels.com/photos/1450363/pexels-photo-1450363.jpeg", short_description: "Sun, parties, beach shacks, NYE bash." },
];

export default function GroupTours() {
  return (
    <ToursList
      type="group"
      title="Travel together. Save together."
      subtitle="Fixed-date group departures — great for solo travelers, families, and senior citizens."
      heroImg="https://images.pexels.com/photos/3935702/pexels-photo-3935702.jpeg"
      fallbackPackages={FALLBACK}
    />
  );
}
